function App() {
  return (
    <div className="App">
      <main id='work' className="row">

        <div className="col s12 m6 l6 project">
          <div className="card medium">
            <div className="card-image waves-effect waves-block waves-light">
              <a href='https://npu-cards-svelte.vercel.app/' rel='noreferrer noopener' target='_blank'>
                <img className='demoPic' alt="NPU Locator"
                  src="https://github.com/UrbaneD0ge/NPU-Cards-svelte/assets/88916382/35cc541b-5ebd-45c8-99ff-8b478748d0c5"></img></a>
            </div>
            <div className="card-action">
              <h2 className="card-title">NPU Locator</h2>
              <a href="https://github.com/UrbaneD0ge/NPU-Cards-svelte" target='_blank' rel="noreferrer" alt="Project Repo Link">View Repo</a>
              <p>My first complete Svelte project, the NPU Locator fills a need for a robust yet lightweight lookup tool.</p>
            </div>
          </div>
        </div>

        <div className="col s12 m6 l6 project">
          <div className="card medium">
            <div className="card-image waves-effect waves-block waves-light">
              <a href='https://bpdb-three.vercel.app/' rel='noreferrer' target='_blank'>
                <img className='demoPic'
                  src="https://github.com/user-attachments/assets/5ad6899d-bf9c-4781-b86a-f944566d4140" alt="BPDB screenshot"></img></a>
            </div>
            <div className="card-action">
              <h2 className="card-title">BPDB</h2>
              <a href="https://github.com/UrbaneD0ge/BPDB" target='_blank' rel='noreferrer' alt="Project Repo Link">View Repo</a>
              <p>The Boiled Peanut DataBase! A personal project utilizing PostgreSQL with Post GIS as the database via SupaBase.</p>
            </div>
          </div>
        </div>

        <div className="col s12 m6 l6 project">
          <div className="card medium">
            <div className="card-image waves-effect waves-block waves-light">
              <a href='https://urbaned0ge.github.io/VotingForm/' rel='noreferrer noopener' target='_blank'>
                <img className='demoPic' target="_blank" rel="noreferrer" alt="DCP Voting Form"
                  src="https://user-images.githubusercontent.com/88916382/181673287-2ce8ea42-6620-4dfd-81e8-7501325f20e8.png"></img></a>
            </div>
            <div className="card-action">
              <h2 className="card-title">DCP Voting Form</h2>
              <a href="https://github.com/UrbaneD0ge/VotingForm" target='_blank' rel='noreferrer' alt="Project Repo Link">View Repo</a>
              <p>An online tool for the Atlanta Department of City Planning to generate and submit NPU voting report
                forms.</p>
            </div>
          </div>
        </div>

        <div className="col s12 m6 l6 project">
          <div className="card medium">
            <div className="card-image waves-effect waves-block waves-light">
              <a href="https://agendenator.onrender.com/" rel='noreferrer noopener' target='_blank'>
                <img className='demoPic'
                  src="https://user-images.githubusercontent.com/88916382/224571269-f60a29ae-f6e2-48cc-86f9-d2924ebfd36a.png" alt="Agendenator" ></img></a>
            </div>
            <div className="card-action">
              <h2 className="card-title">Agendenator</h2>
              <a href="https://github.com/UrbaneD0ge/Agendenator" target='_blank' rel="noreferrer">View Repo</a>
              <p>Database application for procedurally generating NPU agendas. Envisioned as a one-stop resource for Atlanta NPU staff to end duplication of data-entry tasks.</p>
            </div>
          </div>
        </div>

        <div className="col s12 m6 l6 project">
          <div className="card medium">
            <div className="card-image waves-effect waves-block waves-light">
              <a href="https://coaplangis.maps.arcgis.com/apps/dashboards/1f96df45f3444796a0d73efbf18df677" rel='noreferrer noopener' target='_blank'>
                <img className='demoPic'
                  src="https://github.com/UrbaneD0ge/NPU-Cards-svelte/assets/88916382/7d57f105-fcbd-4a5d-a40a-7d6378708544" alt="Agendenator" ></img></a>
            </div>
            <div className="card-action">
              <h2 className="card-title">NPU GIS Dashboard</h2>
              <a href="https://coaplangis.maps.arcgis.com/home/item.html?id=1f96df45f3444796a0d73efbf18df677" target='_blank' rel="noreferrer">View Description</a>
              <p>A public table of 2023 NPU Applications. Built on the ArcGIS Dashboard platform, customized with <a href="https://developers.arcgis.com/arcade/">ARCade</a></p>
            </div>
          </div>
        </div>

        <div className="col s12 m6 l6 project">
          <div className="card medium">
            <div className="card-image waves-effect waves-block waves-light">
              <a href='https://urbaned0ge.github.io/Musical-Time-Machine/' rel='noreferrer noopener' target='_blank'>
                <img className='demoPic' alt="Musical Time Machine"
                  src="https://user-images.githubusercontent.com/89173968/135728428-03d061c8-c073-4b4b-8167-7a74e4c631a1.png"></img></a>
            </div>
            <div className="card-action">
              <h2 className="card-title">The Musical Time Machine</h2>
              <a href="https://github.com/UrbaneD0ge/Musical-Time-Machine" target='_blank' rel="noreferrer" alt="Project Repo Link">View Repo</a>
              <p>On of my first projects: I discovered my interest in front-end development and web design building this
                novelty page with my team.</p>
            </div>
          </div>
        </div>




      </main>
    </div>
  );
}

export default App;
